import React from 'react';
import Styled from 'styled';
import { useQuery } from '@apollo/client/react/hooks';
import { Link } from 'react-router-dom';

import query, { SelectionItemsQuery } from 'four-nets/photoblog/my-selection/selection-items/selection-items.graphql';
import { StyledBadge } from 'four-nets/homepage/homepage/homepage-badge/homepage-badge';

import defaultStyles from './selection-items.scss';

interface Props {
    styles: typeof defaultStyles;
    preceedingItems: JSX.Element[];
}

const SelectionItems: React.FC<Props> = props => {
    const { styles, preceedingItems } = props;
    const { data } = useQuery<SelectionItemsQuery>(query, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-first',
    });

    return (
        <div>
            {preceedingItems.map(item => {
                return <span className={styles.selectionItem}>{item}</span>;
            })}
            {data && data.selectionItems
                ? data.selectionItems.edges.map(edge =>
                      edge && edge.node ? (
                          <Link
                              key={edge.node.id}
                              to={`/blogs/?selection=${edge.node.name}`}
                              className={styles.selectionItem}
                          >
                              <StyledBadge uppercase={true} key={edge.node.id}>
                                  {edge.node.name}
                              </StyledBadge>
                          </Link>
                      ) : null
                  )
                : null}
        </div>
    );
};

SelectionItems.defaultProps = {
    preceedingItems: [],
};

export default Styled(defaultStyles)(SelectionItems);
